import React, { Component, Fragment } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { API } from 'aws-amplify'
// import { Link } from 'react-router-dom'
import { CSSTransition } from 'react-css-transition'
import * as Sentry from '@sentry/browser'
import { createBooking } from '../actions/bookingActions'
import Button from '../components/Button'
import BookingBreadcrumb from '../components/BookingBreadcrumb'
import Spinner from '../components/Spinner'
import TimeSlotSelector from './TimeSlotSelector'
import BookingLib from '../lib/booking'
import { dateEquivalentInCPH } from '../lib/utils'

class BookingWhenPage extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      booking: props.booking,
      isLoading: false,
      selectedTimeConflicted: false,
      workingHours: [],
      overrideHours: [],
      futureBookingLimit: null,
      capacityLimit: null,
      showTimeSlotNotSelectedError: false
    }
    this.updateBooking = this.updateBooking.bind(this)
    this.keyCount      = 0
    this.getKey        = this.getKey.bind(this)
    this.selectedTimeChanged = this.selectedTimeChanged.bind(this)
    this.selectedDateChanged = this.selectedDateChanged.bind(this)
    this.selectedTimeConflicted = this.selectedTimeConflicted.bind(this)
  }

  componentWillMount() {
    window.scrollTo(0, 0); // TODO avoid duplication on all pages
  }              

  async componentDidMount() {
    // Fetch working hours & overrides
    const [workingHoursObject, 
           overrideHours, 
           futureBookingLimit,
           capacityLimit
          ] = await Promise.all([
            BookingLib.getSettings('workingHours'), 
            BookingLib.getOverrides(), 
            BookingLib.getSettings('futureBookingLimit'),
            BookingLib.getSettings('capacityLimit')
          ])
    
    // If successful map working hours to state in desired form
    const workingHours = workingHoursObject ? BookingLib.mapWeekStartToSunday(workingHoursObject.settingValue.days) : []

    this.setState({
      workingHours,
      overrideHours,
      futureBookingLimit: futureBookingLimit ? futureBookingLimit.settingValue.value : 120,
      capacityLimit: capacityLimit ? parseInt(capacityLimit.settingValue.value, 10) : 3
    })

  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  selectedTimeConflicted(value) {
    this.setState({ selectedTimeConflicted: value})
  }
  
  isValid() {
    const { booking, selectedTimeConflicted, workingHours, overrideHours } = this.state
    return (
      booking.whenStartTime
      && booking.whenEndTime
      && !BookingLib.timeIsOutOfBounds(booking.whenEndTime, workingHours, overrideHours)
      && BookingLib.sameDay(booking.whenStartTime, booking.whenEndTime)
      && !selectedTimeConflicted
    )
  }

  async updateBooking() {
    const { props, state } = this
    const { booking } = state
    this.setState({ isLoading: true })
    
    if (this.isValid()) {
      if (!booking.reservation) {
        const reservation = await API.post('cphill', '/reservations', {
          body: {
            dateStart: dateEquivalentInCPH(new Date(booking.whenStartTime)).toISOString(),
            dateEnd: dateEquivalentInCPH(new Date(booking.whenEndTime)).toISOString(),
            amountPeople: booking.amountPeople + booking.amountPeopleKids
          }
        })
        booking.reservation = reservation
      } else {
        try {
          booking.reservation = await API.put('cphill', '/reservations', {
            body: {
              uuid: booking.reservation.uuid,
              dateStart: dateEquivalentInCPH(new Date(booking.whenStartTime)).toISOString(),
              dateEnd: dateEquivalentInCPH(new Date(booking.whenEndTime)).toISOString(),
              amountPeople: booking.amountPeople
            }
          })
        } catch (error) {
          // Do nothing as not mission critical
          Sentry.captureException(error)
        }
      }
      props.createBooking(booking)
      props.history.push('/bookings/people-details')
    } else {
      this.setState({
        ...state,
        showValidationError: true,
        showTimeSlotNotSelectedError: !booking.whenStartTime,
        showDateNotSelectedError: !state.bookingDate
      })
    }
    this.setState({ isLoading: false })
  }

  selectedTimeChanged(startTime, endTime) {
    const { booking } = this.state
    booking.whenStartTime = startTime
    booking.whenEndTime = endTime
    this.setState({ booking })
  }

  selectedDateChanged(bookingDate) {
    this.setState({ bookingDate, showDateNotSelectedError: false })
  }

  render() {
    
    // Strange fix - throws an error in console without this
    // https://github.com/wikiwi/react-css-transition/issues/5
    CSSTransition.childContextTypes = {}

    const { props, state } = this
    const { booking, isLoading, workingHours, overrideHours, futureBookingLimit, capacityLimit } = this.state
    // const { whenDay } = booking

    return (
      <Fragment>

        <BookingBreadcrumb booking={booking} step={2} />

        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mx-auto">
            <h4 className="text-harbor-80 uppercase text-sky">
              <FormattedMessage 
                id="booking.whenForm.category" 
                defaultMessage="New booking"
              />
            </h4>

            <h1 className="border-b pb-6">
              <FormattedMessage id="booking.whenForm.header" defaultMessage="When would you like to go?" />
            </h1>        
          </div>
        </div>

        <TimeSlotSelector
          booking={booking} 
          getKey={this.getKey}
          selectedTimeChanged={this.selectedTimeChanged}
          selectedTimeConflicted={this.selectedTimeConflicted}
          showTimeSlotNotSelectedError={state.showTimeSlotNotSelectedError}
          showDateNotSelectedError={state.showDateNotSelectedError}
          selectedDateChanged={this.selectedDateChanged}
          workingHours={workingHours}
          overrideHours={overrideHours}
          futureBookingLimit={futureBookingLimit}
          capacityLimit={capacityLimit}
        />

        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
            <div className="flex">
              <div className="flex-grow">
                <Button
                  onClick={() => { props.history.goBack() }}
                  // to="/bookings"
                  bgCss='bg-grey'
                  className='text-harbor'
                >
                  <FormattedMessage
                    id="booking.whenForm.buttonBack"
                    defaultMessage="Back"
                  />
                </Button>
              </div>
              {!isLoading ? (
                <Button
                  onClick={this.updateBooking}
                  className={`${this.isValid() ? '' : 'opacity-50 cursor-not-allowed'}`}
                >
                  <FormattedMessage
                    id="booking.whenForm.buttonContinue"
                    defaultMessage="Continue"
                  />
                </Button>
              ) : (
                <Spinner type="compact" />
              )}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

BookingWhenPage.propTypes = {
  booking: PropTypes.shape({ booking: PropTypes.object }).isRequired
}

BookingWhenPage.defaultProps = {}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(injectIntl(BookingWhenPage))